export class Constants {
  static esraDelimiter = '_%$%_';

  // app roles
  static readonly admin: string = 'Admin';
  static readonly user: string = 'User';
  static readonly scanner: string = 'Scanner';

  static readonly coatingSpecificationExport: string =
    'Coatings.Specification.Export';
  static readonly coatingRevisionWriter: string = 'Coatings.Revision.Write';

  static readonly weldingRevisionWriter: string = 'Welding.Revision.Write';

  static readonly pipingRevisionWriter: string = 'Piping.Revision.Write';
  static readonly pipingReleaseWriter: string = 'Piping.Release.Write';
  static readonly pipingDictionaryWriter: string = 'Piping.Dictionary.Write';
  static readonly pipingDictionaryReader: string = 'Piping.Dictionary.Read';
  static readonly valvesBulkUploadWriter: string = 'Piping.Valves.BulkUpload.Write';
  static readonly valvesBulkUploadReader: string = 'Piping.Valves.BulkUpload.Read';
  static readonly pipingRevisionReader: string = 'Piping.Revision.Reader';
  static readonly pipingSasbuAdmin: string = 'piping.sasbu.admin';
  static readonly pipingNmaAdmin: string = 'piping.nma.admin';

  // app routes
  static readonly allRevisionsURL: string = 'allrevisions';
  static readonly coatingRevisions: string = 'coatingsrevision';
  static readonly coatingSystemURL: string = 'coatingsystem';
  static readonly coatingProductURL: string = 'coatingproduct';
  static readonly updateCoatingSolutionURL: string = 'updatecoatingsolution';

  // units
  static readonly metricPipeClassPressureUnits: string = 'kPag';
  static readonly imperialPipeClassPressureUnits: string = 'psig';
  static readonly metricPipeClassTemperatureUnits: string = 'C';
  static readonly imperialPipeClassTemperatureUnits: string = 'F';
}
